import ActionTypes from "core/actions/actionTypes";
import initialState from "./initialState";

export default function reducer(state = {}, action) {
    switch (action.type) {

        case ActionTypes.UPDATE_ITEMS_TO_SHOW: {
            return { ...state, itemsToShow: action.payload };
            break;
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/core/reducers/pageSizeReducer.ts